import { FC, Reducer, useReducer } from 'react';

import { PropsWithOnlyChildren } from 'app/types';
import { parseJWT } from 'app/utils/lib/string';

import {
  AuthContextAction,
  AuthDispatchContext,
  AuthStateContext,
  initialState,
  State,
} from './contexts';

const reducer: Reducer<State, AuthContextAction> = (state, action) => {
  switch (action.type) {
    case 'reset':
      return { ...initialState };
    case 'setLoginInfo': {
      const { token } = action.payload;
      const parsedToken = token ? parseJWT(token) : null;
      const authRoles = parsedToken?.Roles.split(',').map(roleId => Number(roleId)) ?? [];
      const companyId = parsedToken?.CId ?? '';

      return {
        ...state,
        authRoles,
        companyId,
        tokenData: parsedToken,
      };
    }
    case 'updateCookiePermission':
      return {
        ...state,
        areCookiesAllowed: action.payload.areCookiesAllowed,
      };

    default:
      throw new Error();
  }
};

const AuthContextProvider: FC<PropsWithOnlyChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
};

export default AuthContextProvider;
